import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static values = {
    currentPage: Number,
    totalPages: Number,
    salaryCalculationIds: Object,
    userId: String,
    statusValues: Array
  }

  static targets = ["prevButton", "nextButton"]

  connect() {
    this.pageSize = 75
    this.updateButtonStates()
  }

  updateButtonStates() {
    // Update previous button
    if (this.currentPageValue === 0) {
      this.prevButtonTarget.classList.add("opacity-30", "cursor-not-allowed", "pointer-events-none")
    } else {
      this.prevButtonTarget.classList.remove("opacity-30", "cursor-not-allowed", "pointer-events-none")
    }

    // Update next button
    if (this.currentPageValue >= this.totalPagesValue - 1) {
      this.nextButtonTarget.classList.add("opacity-30", "cursor-not-allowed", "pointer-events-none")
    } else {
      this.nextButtonTarget.classList.remove("opacity-30", "cursor-not-allowed", "pointer-events-none")
    }
  }

  previousPage() {
    if (this.currentPageValue > 0) {
      const newPage = this.currentPageValue - 1
      this.navigateToFirstInPage(newPage)
    }
  }

  nextPage() {
    if (this.currentPageValue < this.totalPagesValue - 1) {
      const newPage = this.currentPageValue + 1
      this.navigateToFirstInPage(newPage)
    }
  }

  navigateToFirstInPage(page) {
    const firstSequenceInPage = (page * this.pageSize) + 1
    const salaryCalculationId = this.salaryCalculationIdsValue[String(firstSequenceInPage)]
    
    if (salaryCalculationId) {
      let url = `/salary_calculations/${salaryCalculationId}`
      const params = new URLSearchParams()
      
      if (this.hasUserIdValue && this.userIdValue) {
        params.append("user_id", this.userIdValue)
      }
      
      if (this.hasStatusValuesValue && this.statusValuesValue.length > 0) {
        this.statusValuesValue.forEach(status => {
          params.append("status[]", status)
        })
      }
      
      const queryString = params.toString()
      if (queryString) {
        url += `?${queryString}`
      }
      
      Turbo.visit(url)
    }
  }
}

